import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const models = [
  {
    icon: 'ri-refresh-line',
    title: 'Retainer',
    subtitle: 'Always-on destek',
    features: [
      'Aylık içerik üretimi',
      'Sürekli topluluk yönetimi',
      'Düzenli strateji güncellemeleri',
      'Öncelikli destek',
    ],
  },
  {
    icon: 'ri-rocket-line',
    title: 'Campaign',
    subtitle: '4–8 hafta',
    features: [
      'Belirli hedef odaklı kampanya',
      'Yoğun içerik üretimi',
      'Influencer aktivasyonu',
      'Detaylı performans raporu',
    ],
  },
  {
    icon: 'ri-star-line',
    title: 'Experience',
    subtitle: 'Özel projeler',
    features: [
      'Lansman ve etkinlik tasarımı',
      'PR ve medya yönetimi',
      'Özel içerik üretimi',
      'End-to-end proje yönetimi',
    ],
  },
];

export default function WorkingModels() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="font-serif text-5xl text-charcoal text-center mb-16"
        >
          Çalışma Modelleri
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {models.map((model, index) => (
            <motion.div
              key={model.title}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${model.icon} text-5xl text-charcoal`}></i>
              </div>
              
              <h3 className="font-serif text-3xl text-charcoal mb-1">
                {model.title}
              </h3>
              <p className="font-sans text-sm text-gray-medium italic mb-6">
                {model.subtitle}
              </p>

              <ul className="space-y-3">
                {model.features.map((feature) => (
                  <li
                    key={feature}
                    className="font-sans text-sm text-gray-medium leading-relaxed flex items-start gap-2"
                  >
                    <i className="ri-check-line text-charcoal mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
